import { useState } from "react";
import { Eye, Send } from "lucide-react";
import { useAuth } from "../lib/auth";
import RequestAccessModal from "./RequestAccessModal";

/**
 * Sticky strip rendered above the TopNav when the logged-in user is the
 * shared public demo viewer. Read-only enforcement happens server-side
 * (see DemoReadOnlyMiddleware in server.py); this banner just makes the
 * mode visible and gives a one-click path to convert.
 */
export default function DemoBanner() {
  const { user } = useAuth();
  const [showReq, setShowReq] = useState(false);

  if (!user?.is_demo) return null;

  return (
    <>
      <RequestAccessModal open={showReq} onClose={() => setShowReq(false)} />
      <div
        className="border-b"
        style={{ borderColor: "var(--cyan)", backgroundColor: "rgba(0, 229, 255, 0.08)" }}
        data-testid="demo-banner"
      >
        <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3 min-w-0">
            <Eye size={14} className="text-[var(--cyan)]" strokeWidth={1.5} />
            <span
              className="font-mono text-[11px] tracking-widest uppercase text-[var(--cyan)]"
              data-testid="demo-banner-label"
            >
              Live demo · read-only · explore everything, changes are disabled
            </span>
          </div>
          <button
            onClick={() => setShowReq(true)}
            className="font-mono text-[10px] tracking-widest uppercase border border-[var(--cyan)] text-[var(--cyan)] px-3 py-1.5 hover:bg-[var(--surface)] inline-flex items-center gap-1.5"
            data-testid="demo-banner-cta"
          >
            <Send size={11} /> Request full access
          </button>
        </div>
      </div>
    </>
  );
}
